import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { FormsModule } from "@angular/forms";
import { AngularDraggableModule } from "angular2-draggable";
import { LayoutEditorComponent } from "./layout-editor/layout-editor.component";
import { LayoutsRoutes } from "./layouts.routes";
import { LayoutVisualEditorComponent } from "./layout-visual-editor/layout-visual-editor.component";
import { ZoneEditorComponent } from "./zone-editor/zone-editor.component";
import { ILayoutsRepository } from "../../domain/layouts/layouts.repository";
import { LayoutsRepository } from "../../infrastructure/layouts/layouts.repository";
import { CreateBlockModalComponent } from "../blocks/create-block-modal/create-block-modal.component";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    AngularDraggableModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(LayoutsRoutes),
  ],
  declarations: [
    LayoutEditorComponent,
    LayoutVisualEditorComponent,
    ZoneEditorComponent,
    CreateBlockModalComponent,
  ],
  providers: [
    {
      provide: ILayoutsRepository,
      useClass: LayoutsRepository,
    },
  ],
  exports: [CreateBlockModalComponent],
})
export class LayoutsModule {}
